module.exports = __webpack_public_path__ + "media/images/dqdqwdwq-ebc9fd2a27fc5f2345cab7c79343e73b.webp";